import { render } from "./PayrollStatus.vue?vue&type=template&id=00a50e7b&scoped=true"
import script from "./PayrollStatus.vue?vue&type=script&lang=js"
export * from "./PayrollStatus.vue?vue&type=script&lang=js"

import "./PayrollStatus.vue?vue&type=style&index=0&id=00a50e7b&scoped=true&lang=css"
import "./PayrollStatus.vue?vue&type=style&index=1&id=00a50e7b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a50e7b"]])

export default __exports__